export enum PageTypeEnum {
  JOB_DESCRIPTION = 'JOB_DESCRIPTION',
  MY_PAGE = 'MY_PAGE',
  RESUME_WRITING = 'RESUME_WRITING',
}

export type PageType = keyof typeof PageTypeEnum;
